import { Box, Button, Divider, Grid, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import AppsIcon from '@mui/icons-material/Apps'
import PrintIcon from '@mui/icons-material/Print'
import PdfIcon from '@mui/icons-material/PictureAsPdf'
import ExcelIcon from '@mui/icons-material/FileCopy'
import { transparentStyle } from '../../../DeliveryMemo/const'
import {
  calculateDynamicFormatLandscape,
  calculateDynamicFormatPortrait,
  calculateTotalTableWidth,
  focusElemnt,
  navigation3,
} from '../../../../common/helper'
import moment from 'moment'
import { callAddFontRobotoBold } from '../../../../common/font/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../common/font/Roboto-normal'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import { showOnlyToPayAmountSummaryColumn, showOnlyToPayAmtSummaryExcel } from '../../common/reportConstants'
import ShowOnlyToPayAmtTable from './ShowOnlyToPayAmtTable'
import { checkPaymentTypeIntInArray, groupDataByVehicleAndPayment } from '../../common/reportUtils'
import { exportToExcel } from '../../../../common/hook'
import { makeTable } from '../../analysisReport/pdfAutotable'
import { formatNumber } from '../../../../common/mathHelper'

const ShowOnlyToPayAmt = ({
  UseToPayAsCOD,
  updateModal,
  disableExcel,
  loginData,
  selBranch,
  selDestCity,
  selFromBranch,
  reportData,
  toDate,
  fromDate,
  selVehicle,
  selPaymentTpe,
  reportType,
  showSummaryReport,
  detailedFilter,
  columnDefs,
  selectedFields,
  summarySelectedFields,
  allownFormatLR = 0,
}) => {
  const theme = useTheme()
  const [showTable, setShowTable] = useState(true)
  const [tableData, setTableData] = useState([])
  const [summaryData, setSummaryData] = useState([])
  const [PymtTypeIntPresence, setPymtTypeIntPresence] = useState({})
  const [state, setState] = useState({
    startIndex: 0,
    lastIndex: 8,
    Total: 0,
    TotalAmount: 0,
    generatePDF: false,
    load: false,
  })
  const { generatePDF, load } = state
  const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm')
  const headers = columnDefs.map((item) => {
    return {
      header: item.header,
      field: item.field,
      headerSx: item.headerSx,
      textAlign: item.headerSx?.textAlign || 'left',
    }
  })
  const excelColumns = headers.map((item) => {
    return {
      header: item.header,
      field: item.field,
      textAlign: item.headerSx?.textAlign || 'left',
    }
  })
  useEffect(() => {
    if (reportData.Data?.Table.length > 0) {
      setTableData(groupTableData(reportData.Data?.Table, columnDefs))
      setSummaryData(groupDataByVehicleAndPayment(reportData.Data?.Table))
      setPymtTypeIntPresence(checkPaymentTypeIntInArray(reportData.Data?.Table))
    } else {
      setTableData([{ isNoData: true, caption: 'No results found. Please refine your search parameters and search again.' }])
      setSummaryData([])
      setPymtTypeIntPresence({})
    }
  }, [reportData])
  const groupTableData = (data, headers) => {
    const groupedData = data.reduce((result, item) => {
      const key = `${item.VehicleNo}`
      if (!result[key]) {
        result[key] = []
      }
      result[key].push(item)
      return result
    }, {})
    let newData = []
    Object.keys(groupedData).map((val) => {
      const updateData = groupData(groupedData[val], headers)
      newData = [...newData, ...updateData]
    })
    let groupTotalRow = {
      Quantity: 0,
      NetAmount: 0,
    }
    newData.forEach((obj) => {
      if (obj?.dataType === 'total') {
        groupTotalRow = {
          Quantity: Number((groupTotalRow.Quantity + Number(obj.Quantity))),
          NetAmount: Number((groupTotalRow.NetAmount + Number(obj.NetAmount))),
        }
      }
    })
    const formattedTotalObject = {}
    Object.entries(groupTotalRow).forEach(([key, value]) => {
      formattedTotalObject[key] = formatNumber(value)
    })
    return [
      ...newData,
      {
        dataType: 'total',
        [headers[0].field]: `Total For ALL Vehicles`,
        ...formattedTotalObject,
        colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
        align: { [headers[0].field]: 'right' },
      },
    ]
  }
  const groupData = (data, headers) => {
    let detailedData = []
    let groupTotalRow = {
      Quantity: 0,
      NetAmount: 0,
    }
    detailedData.push({
      [headers[0].field]: `Vehicle No.: ${data[0]?.VehicleNo}`,
      align: { [headers[0].field]: 'left' },
      dataType: 'subHeader',
      colSpan: { [headers[0].field]: headers.length },
    })
    data.forEach((obj) => {
      detailedData.push({ dataType: 'entry', ...obj, NetAmount: [2, 4, 7, 9].includes(obj.PaymentTypeInt) ? obj.NetAmount : 0 })
      if ([2, 4, 7, 9].includes(obj.PaymentTypeInt)) {
        groupTotalRow = {
          Quantity: Number((groupTotalRow.Quantity + Number(obj.Quantity)).toFixed(2)),
          NetAmount: Number((groupTotalRow.NetAmount + Number(obj.NetAmount)).toFixed(2)),
        }
      } else {
        groupTotalRow = {
          ...groupTotalRow,
          Quantity: Number((groupTotalRow.Quantity + Number(obj.Quantity)).toFixed(2)),
        }
      }
    })
    return [
      ...detailedData,
      {
        dataType: 'total',
        [headers[0].field]: `Total For Vehicle No: ${data[0]?.VehicleNo}`,
        ...groupTotalRow,
        colSpan: { [headers[0].field]: headers.findIndex((item) => item.field === 'Quantity') },
        align: { [headers[0].field]: 'right' },
      },
    ]
  }
  const mainHeader = ['LRNO', 'OnlyLRNo', 'ManualLR', 'FormattedLRNO', 'SenderName', 'SenderGSTN', 'RecName', 'ReceiverGSTN']
  const matchFields = Object.fromEntries(Object.entries(selectedFields).filter(([key]) => mainHeader.includes(key)))
  const printReport = (isSave = false) => {
    setShowTable(false)
    setState({ ...state, load: true, generatePDF: true })
    let PymtTypeIntPreCol = Object.fromEntries(Object.entries(summarySelectedFields).filter(([key, value]) => value === true))
    let updatedColumns = []
    if (UseToPayAsCOD === 1) {
      updatedColumns = showOnlyToPayAmountSummaryColumn
        .map((col) => {
          if (col.field === 'toPayQuantity') return { ...col, headerName: 'COD \nUnit', exportHead: 'COD\nUnit' }
          if (col.field === 'toPayAmount') return { ...col, headerName: 'COD \nAmt.', exportHead: 'COD\nAmt.' }
          if (col.field === 'toPay(Manual)Quantity') return { ...col, headerName: 'COD (Manual) \nUnit', exportHead: 'COD (Manual)\nUnit' }
          if (col.field === 'toPay(Manual)Amount') return { ...col, headerName: 'COD (Manual) \nAmt.', exportHead: 'COD (Manual)\nAmt.' }
          if (col.field === 'toPay(DDDV)Quantity') return { ...col, headerName: 'COD (DDDV) \nUnit', exportHead: 'COD (DDDV)\nUnit' }
          if (col.field === 'toPay(DDDV)Amount') return { ...col, headerName: 'COD (DDDV) \nAmt.', exportHead: 'COD (DDDV)\nAmt.' }
          return col
        })
        .filter((col) => col.field !== 'cODQuantity' || col.field !== 'cODAmount')
    }
    const summaryCol = updatedColumns.filter((item) => PymtTypeIntPreCol.hasOwnProperty(item?.field1) || item?.field1 == '0')

    const widthCell = calculateTotalTableWidth(summaryCol)
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoNormal])
    const doc = new jsPDF({
      orientation: summaryCol.length > 12 ? 'l' : 'p',
      format:
        summaryCol.length > 12
          ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60)
          : calculateDynamicFormatPortrait((widthCell > 1200 ? widthCell : 1200) + 60),
      unit: 'px',
      compress: true,
    })
    doc.setProperties({
      title: `Vehicle wise Dispatch.pdf`,
      subject: 'Vehicle wise Dispatch Report',
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, LRWise',
      creator: 'MTLPL',
    })
    var pageSize = doc.internal.pageSize
    var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
    var scaleFactor = pageWidth / (summaryCol.length > 12 ? 1122 : 793)
    var totalPagesExp = '{total_pages_count_string}'
    const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
      const doc = data.doc
      var str = 'Page : ' + doc.internal.getNumberOfPages()
      if (typeof doc.putTotalPages === 'function') {
        str = str + ' of ' + totalPagesExp
      }
      doc.setFontSize(scaleFactor * 14)
      doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
      doc.setFont('Roboto', 'bold')
      doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
      doc.text(
        `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
        doc.internal.pageSize.width / 2 -
          (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
            2 +
          90,
        pageHeight - 5
      )
    }
    const HeaderColumn = [
      {
        headerName: 'Dispatch By Branch',
        exportHead: 'Dispatch By Branch',
        field: 'selFromBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Destination City',
        exportHead: 'Destination City',
        field: 'selDestCity',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Destination Branch',
        exportHead: 'Destination Branch',
        field: 'selBranch',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        headerName: 'Vehicle Number',
        exportHead: 'Vehicle Number',
        field: 'selVehicle',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    const HeaderColumns = HeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    const HeaderData = [
      {
        selFromBranch: selFromBranch?.name || loginData?.strBranchName,
        selDestCity: selDestCity?.name,
        selBranch: selBranch?.name,
        selVehicle: selVehicle?.name,
        selPaymentTpe: selPaymentTpe?.name || 'All',
        reportType: reportType?.Name,
        showSummaryReport: showSummaryReport?.Name,
        detailedFilter: detailedFilter?.Name,
      },
    ]
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns,
      body: HeaderData,
      startY: 160,
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        fontStyle: 'normal',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      columnStyles: {
        0: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        1: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        2: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        3: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
      },
      didDrawPage: function (data) {
        doc.setTextColor(0, 0, 0)
        doc.setFontSize(scaleFactor * 16).setFont('Roboto', 'bold')
        doc.text(
          `From Dispatch : ${moment(fromDate).format('DD-MMM-YYYY')} To ${moment(toDate).format('DD-MMM-YYYY')}`,
          data.settings.margin.left,
          150
        )
        doc.text(`Detailed-Show Only ToPay Amount`, doc.internal.pageSize.width - data.settings.margin.left, 150, 'right')
        jsPdfHeaderFooter(data, loginData, totalPagesExp)
      },
      showHead: 'firstPage',
    })
    const HeaderColumns1 = [
      {
        header: 'Payment Type',
        dataKey: 'selPaymentTpe',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        header: 'Report Type',
        dataKey: 'reportType',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        header: 'Report View',
        dataKey: 'showSummaryReport',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
      {
        header: 'Report Option',
        dataKey: 'detailedFilter',
        xlCol: { dataType: 'string', dataFormatter: null },
      },
    ]
    autoTable(doc, {
      margin: { top: 60, left: 30, right: 30, bottom: 5 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },
      columns: HeaderColumns1,
      body: HeaderData,
      startY: doc.lastAutoTable.finalY,
      theme: 'grid',
      headStyles: {
        fillColor: [191, 225, 255],
        textColor: [0, 0, 0],
        minCellHeight: 36,
        valign: 'middle',
        cellPadding: 12,
        fontSize: scaleFactor * 14,
        fontStyle: 'normal',
        font: 'Roboto',
        lineWidth: 0.6,
      },
      columnStyles: {
        0: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        1: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        2: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
        3: {
          fontSize: scaleFactor * 14,
          textColor: [0, 0, 0],
          cellPadding: 12,
          minCellHeight: 36,
          minCellWidth: summaryCol.length > 12 ? 280 : 250,
          valign: 'middle',
          font: 'Roboto',
          fontStyle: 'normal',
          halign: 'left',
        },
      },
      showHead: 'firstPage',
    })
    let pdfColumns = columnDefs.map((col) => {
      return { header: col.pdfHead, dataKey: col.field, xlCol: col.xlCol }
    })
    makeTable(doc, autoTable, pdfColumns, tableData, 1.5, 'Show Only ToPay Amount', loginData, 'everyPage', () => {}, 120, false)
    const pdfSummaryCol = summaryCol.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    makeTable(doc, autoTable, pdfSummaryCol, summaryData, 1.5, 'Show Only ToPay Amount', loginData, 'everyPage', () => {}, 120, false)
    doc.setFont('Roboto')
    if (typeof doc.putTotalPages === 'function') {
      doc.putTotalPages(totalPagesExp)
    }
    if (isSave) {
      doc.save(`Show Only ToPay Amount ${currentDateTime}.pdf`)
    }
    setTimeout(() => {
      setState({ ...state, generatePDF: false, load: true })
      const pdfUrl = doc.output('bloburl')
      document.getElementById('output').data = pdfUrl
      // document.getElementById('output').data = doc.output('datauristring', 'Show Only ToPay Amount.pdf')
      focusElemnt('DispatchBackBtn')
    }, 2000)
  }

  return (
    <>
      <div
        className="print-input-btn"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          padding: '12px 16px',
          width: '100%',
          marginBottom: '-10px',
        }}
      >
        {showTable ? (
          <>
            <Box style={{ display: 'flex', width: '100%', height: '32px', padding: '12px 0px', marginRight: '0px' }}>
              <Box
                style={{
                  display: 'flex',
                  width: '50%',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  gap: '12px',
                  fontSize: '14px',
                }}
              >
                <h3 style={{ textAlign: 'left', color: '#444' }}>Detailed View - Show Only ToPay Amount</h3>
                <Box
                  style={{
                    height: '32px',
                    display: 'flex',
                    padding: '8px 12px',
                    justifycontent: 'center',
                    alignitems: 'center',
                    gap: '6px',
                  }}
                  id="dispatchReportManageColumn"
                  tabIndex={0}
                  onClick={() => updateModal(true, 'showManageColumn')}
                >
                  <span tabIndex={0} style={{ display: 'flex', margin: '-3px' }}>
                    <AppsIcon />
                  </span>
                  <span tabIndex={0} style={{ fontWeight: 'bold' }}>
                    MANAGE COLUMNS
                  </span>
                </Box>
              </Box>
              <Box
                style={{
                  display: 'flex',
                  width: '50%',
                  justifyContent: 'end',
                  alignItems: 'center',
                }}
              >
                <Grid item xs={6} md={2}>
                  <Button
                    id="DispatchPrintBtn"
                    startIcon={<PrintIcon />}
                    variant="contained"
                    color="primary"
                    style={{ ...transparentStyle(theme), fontSize: '100%' }}
                    onClick={() => {
                      setShowTable(false)
                      printReport()
                    }}
                    onKeyDown={(e) => navigation3(e, disableExcel ? 'DispatchPdfBtn' : 'xls-button-dispatch', 'generateBtn', () => {})}
                  >
                    Print
                  </Button>
                </Grid>
                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                />
                {disableExcel ? null : (
                  <Grid item xs={6} md={2}>
                    <Button
                      onKeyDown={(e) => navigation3(e, 'DispatchPdfBtn', 'DispatchPrintBtn', () => {})}
                      id="xls-button-dispatch"
                      startIcon={<ExcelIcon />}
                      variant="contained"
                      color="primary"
                      style={{ ...transparentStyle(theme), fontSize: '100%' }}
                      onClick={(e) => {
                        e.preventDefault()
                        exportToExcel({
                          fileName: `Dispatch Report(Show Only ToPay Amount) ${currentDateTime}.xlsx`,
                          sheetName: 'ShowOnlyToPayAmount',
                          headersList: [excelColumns, showOnlyToPayAmtSummaryExcel],
                          dataList: [tableData, summaryData],
                        })
                      }}
                    >
                      EXPORT AS EXCEL
                    </Button>
                  </Grid>
                )}

                <Divider
                  orientation="vertical"
                  flexItem
                  style={{ width: '2px', margin: '0', height: '15px', alignSelf: 'center', backgroundColor: '#ccc' }}
                />
                <Button
                  startIcon={<PdfIcon />}
                  variant="contained"
                  id="DispatchPdfBtn"
                  onKeyDown={(e) => navigation3(e, 'fromDate', 'xls-button-dispatch', () => {})}
                  color="primary"
                  style={{ ...transparentStyle(theme), fontSize: '100%' }}
                  onClick={() => {
                    setShowTable(false)
                    printReport(true)
                  }}
                >
                  Export as PDF
                </Button>
              </Box>
            </Box>
          </>
        ) : (
          <>
            <Box className="export-as-pdf" style={{ paddingTop: '7px' }}>
              <Button
                variant="contained"
                id="DispatchBackBtn"
                onKeyDown={(e) => navigation3(e, 'fromDate', 'generateBtn', () => {})}
                onClick={() => {
                  setShowTable(true)
                  focusElemnt('generateBtn')
                }}
                style={{
                  borderRadius: '5px',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  fontSize: '15px',
                  color: '#fe5200',
                  background: 'white',
                  marginLeft: '10px',
                  border: '2px solid #fe5200',
                }}
              >
                BACK
              </Button>
            </Box>
          </>
        )}
      </div>
      {showTable ? (
        <ShowOnlyToPayAmtTable
          UseToPayAsCOD={UseToPayAsCOD}
          loginData={loginData}
          selBranch={selBranch}
          selFromBranch={selFromBranch}
          selDestCity={selDestCity}
          tableData={tableData}
          reportType={reportType}
          summaryData={summaryData}
          columnDefs={headers}
          selectedFields={selectedFields}
          matchFields={matchFields}
          summarySelectedFields={summarySelectedFields}
          PymtTypeIntPresence={Object.fromEntries(Object.entries(PymtTypeIntPresence).filter(([key, value]) => value === true))}
          allownFormatLR={allownFormatLR}
        />
      ) : (
        <>
          {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
          {load ? (
            <Box sx={{ ...sx.reportFlex, justifyContent: 'center' }}>
              <object
                id="output"
                type="application/pdf"
                width="100%"
                height="440"
                title="MTLPL -Cargo System - After Transfer Summary Report"
                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
              ></object>
            </Box>
          ) : (
            ''
          )}
        </>
      )}
    </>
  )
}

export default ShowOnlyToPayAmt
